<div class="ste-modal" [ngStyle]="themeVars">
	<div class="modal-header">
		<h4 class="modal-title">
			<i class="material-icons ste-title-icon">flag</i>
			Sales Targets
		</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()">
			<i class="fa fa-close"></i>
		</button>
	</div>

	<div class="modal-body">
		<div class="ste-controls">
			<label class="ste-field">
				<span>Target for</span>
				<select class="form-control form-control-sm" [(ngModel)]="targetType" (ngModelChange)="onTypeChange()">
					<option value="location">Location</option>
					<option value="salesman">Salesperson</option>
				</select>
			</label>
			<label class="ste-field ste-field--wide">
				<span>{{ targetType === 'location' ? 'Location' : 'Salesperson' }}</span>
				<select class="form-control form-control-sm" [(ngModel)]="targetKey" (ngModelChange)="onContextChange()">
					<option value="">— select —</option>
					<option *ngFor="let option of entityOptions" [value]="entityValue(option)">{{ entityLabel(option) }}</option>
				</select>
			</label>
			<label class="ste-field">
				<span>Year</span>
				<input type="number" class="form-control form-control-sm" [(ngModel)]="year" (ngModelChange)="onContextChange()" min="2000" max="2100" />
			</label>
		</div>

		<div class="ste-loading" *ngIf="loading">
			<svg class="spinner" width="30" height="30" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
				<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
			</svg>
		</div>

		<ng-container *ngIf="targetKey && !loading">
			<div class="ste-grid">
				<div class="ste-month" *ngFor="let month of months; let first = first">
					<span class="ste-month-label">{{ month.label }}</span>
					<input type="number" class="form-control form-control-sm text-right"
						[(ngModel)]="month.amount" min="0" step="100" placeholder="0" />
					<button type="button" class="ste-copy-btn" *ngIf="first"
						(click)="copyToAll(month)" title="Copy this amount to all months">
						<i class="material-icons">content_copy</i> all
					</button>
				</div>
			</div>

			<div class="ste-summary">
				<span>Year total: <strong>{{ yearTotal | currency }}</strong></span>
				<span class="ste-dirty" *ngIf="dirtyCount">{{ dirtyCount }} unsaved change{{ dirtyCount === 1 ? '' : 's' }}</span>
			</div>
		</ng-container>

		<p class="text-muted ste-hint" *ngIf="!targetKey && !loading">
			Pick a {{ targetType === 'location' ? 'location' : 'salesperson' }} to view and set monthly targets.
		</p>

		<p class="text-danger mb-0" *ngIf="saveError">{{ saveError }}</p>
	</div>

	<div class="modal-footer">
		<button type="button" class="btn btn-secondary btn-sm" (click)="activeModal.dismiss()">Close</button>
		<button type="button" class="btn btn-success btn-sm" (click)="save()" [disabled]="!targetKey || saving || !dirtyCount">
			{{ saving ? 'Saving…' : 'Save Targets' }}
		</button>
	</div>
</div>
